<template>
    <div class="login-type-add-form-body-inputs">
        <app-stepper-section
            :label="$t('message.loginPersonalize.message.form')"
            class="type-login"
        >
            <v-text-field
                :value="value.name"
                @blur="sendFormData($event.target.value, 'name')"
                :name="$t('message.generics.message.name')"
                class="name"
                :label="$t('message.generics.message.name')"
                v-validate="'required'"
                :error-messages="
                    errors.collect($t('message.generics.message.name'))
                "
            ></v-text-field>
            <v-text-field
                :value="value.loginButtonLabel"
                @blur="sendFormData($event.target.value, 'loginButtonLabel')"
                :name="$t('message.loginPersonalize.message.loginButtonLabel')"
                class="name"
                :label="$t('message.loginPersonalize.message.loginButtonLabel')"
                v-validate="'required'"
                :error-messages="
                    errors.collect(
                        $t('message.loginPersonalize.message.loginButtonLabel')
                    )
                "
            ></v-text-field>
            <app-select
                class="type-body-loginType"
                :data-title="
                    $t('message.loginPersonalize.message.selectRequiredField')
                "
                :clearable="true"
                :data-search="false"
                :value="value.type"
                :data-items="types"
                @input="sendFormData($event, 'type')"
            />
            <app-stepper-section
                v-if="value.type !== 'BILLING'"
                :label="$t('message.spots.message.connectionTimeout')"
                inline
                id="timeout-container"
                class="alinhar-items"
            >
                <app-select
                    class="creation-body-timeout"
                    :value="value.timeoutUnit"
                    :data-title="$t('message.spots.message.select')"
                    :data-search="false"
                    :data-items="timeoutTypes"
                    data-menu-width="fit-content"
                    clearable
                    @input="sendFormData($event, 'timeoutUnit')"
                />
                <v-text-field
                    :label="$t('message.spots.message.timeout')"
                    name="Tempo"
                    :value="value.timeoutValue"
                    v-validate="isTimeoutRequired"
                    mask="#####"
                    return-masked-value
                    :error-messages="
                        errors.collect($t('message.spots.message.timeout'))
                    "
                    @blur="sendFormData($event.target.value, 'timeoutValue')"
                >
                </v-text-field>
            </app-stepper-section>
            <app-select
                v-if="value.type === 'EXTERNAL_SERVICE'"
                :data-title="
                    $t('message.loginPersonalize.message.externalService')
                "
                :value="value.externalServiceId"
                @input="sendFormData($event, 'externalServiceId')"
                class="type-body-external-service"
                :data-items="externalServicesOptions"
            />
            <app-select
                v-if="value.type === 'ACTIVE_DIRECTORY'"
                :data-title="$t('Active Directory')"
                :value="value.externalServiceId"
                @input="sendFormData($event, 'externalServiceId')"
                class="type-body-external-service"
                :data-items="activeDirectoryOptions"
            />

            <app-select
                v-if="value.type === 'GOOGLE'"
                :data-title="'Google'"
                :value="value.externalServiceId"
                @input="sendFormData($event, 'externalServiceId')"
                class="type-body-external-service"
                :data-items="googleOptions"
            />

            <app-select
                v-if="value.type === 'GOV_BR'"
                :data-title="'gov.br'"
                :value="value.externalServiceId"
                @input="sendFormData($event, 'externalServiceId')"
                class="type-body-integration"
                :data-items="govBrOptions"
            />

            <app-select
                v-if="value.type === 'BILLING'"
                :data-title="'Pagamento'"
                :value="value.externalServiceId"
                @input="sendFormData($event, 'externalServiceId')"
                class="type-body-integration"
                :data-items="billingOptions"
            />

            <app-select
                v-if="value.type === 'VOUCHER'"
                data-title="Voucher"
                :value="value.segmentVoucherId"
                @input="sendFormData($event, 'segmentVoucherId')"
                class="type-body-voucher"
                :data-items="vouchersOptions"
            />

            <app-select
                v-if="value.type !== 'MAC'"
                :data-title="$t('message.campaigns.message.integration')"
                :value="value.integrationId"
                @input="sendFormData($event, 'integrationId')"
                class="type-body-integration"
                :data-items="integrationOptions"
            />

            <checkbox
                v-if="isEdit"
                class="checkbox-default custom-checkbox"
                v-model="value.isDefault"
                :label="$t('message.spots.message.setDefaultCaptiveLogin')"
                hide-details
            />
            <captive-form-modal-general-advanced-configs
                v-model="advancedConfigs"
                :isEdit="isEdit"
                :type="value.type"
            />
        </app-stepper-section>
        <confirmation-modal
            :value="showingPhoneValidationWarningModal"
            confirm-label="Fechar"
            is-only-one-button
            @confirm="hidePhoneValidationWarningModal"
            @cancel="hidePhoneValidationWarningModal"
        >
            <span slot="heading">
                {{
                    $t(
                        "message.loginPersonalize.message.activatePhoneValidation"
                    )
                }}
            </span>
            <span>
                {{
                    $t(
                        "message.loginPersonalize.message.phoneValidationWarning"
                    )
                }}
            </span>
        </confirmation-modal>
    </div>
</template>

<script>
import { cloneDeep } from "lodash";
import AppStepperSection from "@components/StepperSection";
import AppSelect from "@components/Select";
import Checkbox from "../../../../Checkbox.vue";
import ConfirmationModal from "../../../../ConfirmationModal.vue";
import CaptiveFormModalGeneralAdvancedConfigs from "./components/CaptiveFormsModalGeneralAdvancedConfigs.vue";

export default {
    components: {
        AppSelect,
        AppStepperSection,
        Checkbox,
        ConfirmationModal,
        CaptiveFormModalGeneralAdvancedConfigs,
    },
    data() {
        return {
            page: 0,
            loginType: undefined,
            form: {
                name: undefined,
                type: undefined,
                isDefault: false,
                integrationId: undefined,
                timeoutUnit: null,
                timeoutValue: undefined,
            },
            timeoutTypes: [
                {
                    id: "MINUTO",
                    label: this.$t("message.spots.message.minute"),
                },
                { id: "HORA", label: this.$t("message.spots.message.hour") },
            ],
            showingPhoneValidationWarningModal: false,
        };
    },

    props: {
        test: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
        },
        value: {
            type: Object,
        },
        integrationsList: {
            type: Array,
        },
        externalServicesList: {
            type: Array,
        },
        vouchersList: {
            type: Array,
        },
        activeDirectoryList: {
            type: Array,
        },
        googleList: {
            type: Array,
        },
        govBrList: {
            type: Array,
        },
        billingList: {
            type: Array,
        },
    },

    computed: {
        advancedConfigs: {
            get() {
                return {
                    isValidatePhoneNumber: this.value.isValidatePhoneNumber,
                    isValidateEmail: this.value.isValidateEmail,
                    vlan: this.value.vlan,
                    ssidFilter: this.value.ssidFilter || [],
                    allSsidSelected: this.value.allSsidSelected,
                };
            },
            set(val) {
                this.setAdvancedConfigs(val);
            },
        },
        isEdit() {
            return !!this.item;
        },
        types() {
            const list = [
                { id: "CPF", label: "CPF" },
                {
                    id: "EMAIL",
                    label: this.$t("message.generics.message.email"),
                },
                {
                    id: "MAC",
                    label: this.$t("message.loginPersonalize.message.noForm"),
                },
                {
                    id: "EXTERNAL_SERVICE",
                    label: this.$t(
                        "message.loginPersonalize.message.externalService"
                    ),
                },
                { id: "VOUCHER", label: "Voucher" },
                { id: "ACTIVE_DIRECTORY", label: "Active Directory" },
                { id: "GOOGLE", label: "Google" },
                { id: "GOV_BR", label: "GOV BR" },
                {
                    id: "CELLPHONE",
                    label: this.$t(
                        "message.loginPersonalize.message.telephone"
                    ),
                },
            ];

            if (this.canUseBilling) {
                list.push({
                    id: "BILLING",
                    label: "Pagamento",
                });
            }

            return list;
        },
        integrationOptions() {
            return (
                this.integrationsList &&
                this.integrationsList.map((integration) => {
                    return {
                        id: integration.id,
                        label: integration.name,
                    };
                })
            );
        },
        externalServicesOptions() {
            return (
                this.externalServicesList &&
                this.externalServicesList.map((externalService) => {
                    return {
                        id: externalService.id,
                        label: externalService.name,
                    };
                })
            );
        },
        activeDirectoryOptions() {
            return (
                this.activeDirectoryList &&
                this.activeDirectoryList.map((activeDirectory) => {
                    return {
                        id: activeDirectory.id,
                        label: activeDirectory.name,
                    };
                })
            );
        },
        googleOptions() {
            return (
                this.googleList &&
                this.googleList.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                    };
                })
            );
        },
        govBrOptions() {
            return (
                this.govBrList &&
                this.govBrList.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                    };
                })
            );
        },
        vouchersOptions() {
            return (
                this.vouchersList &&
                this.vouchersList.map((voucher) => {
                    return {
                        id: voucher.id,
                        label: voucher.name,
                    };
                })
            );
        },

        billingOptions() {
            return (
                this.billingList &&
                this.billingList.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                    };
                })
            );
        },

        isTimeoutRequired() {
            return this.value.timeoutUnit ? "required" : "";
        },
        userPermissions() {
            return this.$store.state.users.user.permissions;
        },
        canUseMarketingModule() {
            return this.userPermissions.find(
                (x) => x === "USE_MARKETING_MODULE"
            );
        },
        canUseBilling() {
            return this.userPermissions.find((x) => x === "USE_BILLING_MODULE");
        },
    },

    methods: {
        emitBack() {
            this.$emit("back");
        },
        hideModal() {
            this.emitInput(false);
        },
        async validate() {
            await this.$validator.validateAll();

            if (this.$validator.errors.items.length !== 0)
                return this.$emit("to-general-tab");

            this.$emit("valid");
        },
        sendFormData(val, key) {
            const newVal = cloneDeep(this.value);
            newVal[key] = val;
            this.$emit("input", newVal);
        },
        showPhoneValidationWarningModal(val) {
            if (val) this.showingPhoneValidationWarningModal = true;
        },
        hidePhoneValidationWarningModal() {
            this.showingPhoneValidationWarningModal = false;
        },
        setAdvancedConfigs(advancedConfigs) {
            const newVal = {
                ...this.value,
                ...advancedConfigs,
            };

            this.$emit("input", newVal);
        },
    },
};
</script>

<style lang="scss">
.login-type-add-form-body-inputs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.type-login {
    display: inline;
    padding-bottom: 20px !important;

    #timeout-container {
        text-align: left;
        font-size: 14px;
        padding-bottom: 15px;

        .stepper-section-body {
            display: flex;
            gap: 10px;
        }

        h4 {
            font-weight: 400 !important;
        }
    }

    .custom-checkbox {
        margin-bottom: 25px;
    }
}

.type-body-integration {
    margin: 0 auto 19px;
}

.type-body-external-service {
    margin: 0 auto 15px;
}

.type-body-voucher {
    margin: 0 auto 15px;
}

.type-body-loginType {
    margin-bottom: 20px;
    border-radius: 0 !important;

    button {
        .btn-extra-round {
            border-radius: 0 !important;
        }
        .btn-secondary {
            border: none;
            border-bottom: 1px solid #8f8f8f;
            transition: 0.5s;

            &:hover {
                border-color: black;
            }
        }
        .dropdown-btn {
            padding-left: 0;
            width: 339px;
        }
    }

    .dropdown-menu {
        right: 50%;
        width: 345px !important;

        ul {
            margin-top: 0 !important;
        }
    }
}
</style>
